import { useModal } from "hooks/useModal"
import { useAppDispatch } from "reducers/store"

import styled from "styled-components"
import { useCallback, memo } from "react"
import IconEdit from "components/EvtKit/icons/IconEdit"
import { setAccount } from "reducers/accounts/accounts-actions"

const InlineButton = styled.div`
  width: 25px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  margin: 16px;
`

interface EditAccountButtonProps {
  account: App.Account
}

const EditAccountButton = (props: EditAccountButtonProps) => {
  const { account } = props

  const appDispatch = useAppDispatch()

  const { openModal } = useModal()

  const handleOnClick = useCallback(async () => {
    appDispatch(setAccount(account))
    openModal("update")
  }, [account])

  return (
    <InlineButton onClick={handleOnClick}>
      <IconEdit />
    </InlineButton>
  )
}

export default memo(EditAccountButton)
